import { render, staticRenderFns } from "./ReceiptUpload.vue?vue&type=template&id=488f34fa"
import script from "./ReceiptUpload.vue?vue&type=script&lang=js"
export * from "./ReceiptUpload.vue?vue&type=script&lang=js"
import style0 from "./ReceiptUpload.vue?vue&type=style&index=0&id=488f34fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports